import {Pattern, match} from 'ts-pattern';

import {FinancingBlockedReasonSchemaSaleVehiclePhoto} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {FinancingPromoPlaceholder} from '../types/FinancingPromoPlaceholder';
import {getFinancingPromoStatusText} from './getFinancingPromoStatusText';

// Text of a gallery placeholder tile. A reason the FE does not know is never shown verbatim:
// FAILED free text is technical and a new BLOCKED reason has no wording yet.
export const getFinancingPlaceholderText = (
  placeholder: Pick<FinancingPromoPlaceholder, 'status' | 'reason' | 'sourcePhotoIndex'>
) =>
  match({
    ...placeholder,
    isKnownReason: FinancingBlockedReasonSchemaSaleVehiclePhoto.safeParse(placeholder.reason)
      .success,
  })
    .with({status: 'PENDING'}, () => i18n.t('entity.advertisingPlatforms.labels.generating'))
    .with({reason: 'MISSING_PHOTO', sourcePhotoIndex: Pattern.number}, ({sourcePhotoIndex}) =>
      i18n.t('entity.photo.financingPromo.reasons.missingPhotoNumber', {number: sourcePhotoIndex})
    )
    .with({status: 'FAILED', isKnownReason: false}, () =>
      i18n.t('entity.photo.financingPromo.status.failed')
    )
    .with({status: 'BLOCKED', isKnownReason: false}, () =>
      i18n.t('entity.photo.financingPromo.reasons.unknown')
    )
    .otherwise(getFinancingPromoStatusText);
